module.exports = __webpack_public_path__ + "img/sdk-1-2.3780383.svg";